import { isKuperTariffMode, TariffMode } from "@/types/base";
import { EDA_SCALE, KUPER_SCALE, PURPLE_SCALE } from "@/utils/helpers";

type PinDisplayConfig = {
  subtractMin: boolean;
  prefix: "" | "+" | "~";
  suffix: "" | "/ч";
};

type TariffModeConfig = {
  colorScale: readonly string[];
  borderColor: string;
  useSnapshots: boolean;
  zeroBasedRange: boolean;
  pin: PinDisplayConfig;
};

const TAXI_CONFIG: TariffModeConfig = {
  colorScale: PURPLE_SCALE,
  borderColor: "#DD6DF6",
  useSnapshots: true,
  zeroBasedRange: false,
  pin: {
    subtractMin: true,
    prefix: "+",
    suffix: "",
  },
};

const EDA_CONFIG: TariffModeConfig = {
  colorScale: EDA_SCALE,
  borderColor: "#FFB347",
  useSnapshots: true,
  zeroBasedRange: true,
  pin: {
    subtractMin: false,
    prefix: "~",
    suffix: "/ч",
  },
};

const KUPER_CONFIG: TariffModeConfig = {
  colorScale: KUPER_SCALE,
  borderColor: "#21A038",
  useSnapshots: true,
  zeroBasedRange: true,
  pin: {
    subtractMin: false,
    prefix: "~",
    suffix: "",
  },
};

export function getTariffModeConfig(tariffMode: TariffMode): TariffModeConfig {
  if (isKuperTariffMode(tariffMode)) return KUPER_CONFIG;
  if (tariffMode.startsWith("eda_")) return EDA_CONFIG;
  return TAXI_CONFIG;
}
